import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Coffee, Search } from 'lucide-react';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1f2937] to-[#111827] flex items-center justify-center p-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          {/* Coffee cup illustration */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <Coffee className="w-32 h-32 text-[#a15507]" />
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-red-500 rounded-full flex items-center justify-center animate-bounce">
                <span className="text-white text-sm font-bold">?</span>
              </div>
            </div>
          </div>
          
          {/* Large 404 */}
          <div className="text-6xl md:text-8xl font-bold text-[#a15507] mb-4">
            404
          </div>
        </div>

        {/* Error Message */}
        <div className="mb-10">
          <h1 className="text-2xl md:text-3xl font-bold text-white mb-4">
            {t('notFound.title')}
          </h1>
          <p className="text-lg text-gray-300 mb-3">
            {t('notFound.message')}
          </p>
          <p className="text-gray-400 text-base">
            {t('notFound.suggestion')}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <Link
            to="/"
            className="flex items-center px-8 py-3 bg-[#a15507] hover:bg-[#8b4606] text-white rounded-lg transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            <Home className="w-5 h-5 mr-2" />
            {t('notFound.goHome')}
          </Link>

          <button
            onClick={() => window.history.back()}
            className="flex items-center px-8 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            {t('notFound.goBack')}
          </button>
        </div>

        {/* Quick Links */}
        <div className="border-t border-gray-700 pt-8 mb-8">
          <h3 className="text-lg font-semibold text-white mb-6">
            {t('notFound.quickLinks')}
          </h3>
          <div className="flex flex-wrap justify-center gap-6">
            <Link
              to="/blog"
              className="text-[#a15507] hover:text-[#8b4606] transition-colors duration-200 font-medium"
            >
              {t('notFound.links.blog')}
            </Link>
            <Link
              to="/login"
              className="text-[#a15507] hover:text-[#8b4606] transition-colors duration-200 font-medium"
            >
              {t('notFound.links.login')}
            </Link>
            <Link
              to="/register"
              className="text-[#a15507] hover:text-[#8b4606] transition-colors duration-200 font-medium"
            >
              {t('notFound.links.register')}
            </Link>
          </div>
        </div>

        {/* Search Suggestion */}
        <div className="p-6 bg-gray-800/50 rounded-lg border border-gray-700 mb-6">
          <div className="flex items-center justify-center text-gray-400 mb-3">
            <Search className="w-5 h-5 mr-2" />
            <span className="font-medium">{t('notFound.searchHint')}</span>
          </div>
          <p className="text-sm text-gray-500">
            {t('notFound.searchDescription')}
          </p>
        </div>

        {/* Coffee-themed message */}
        <div className="text-gray-500 text-sm italic flex items-center justify-center">
          <span className="mr-2">☕</span>
          {t('notFound.coffeeMessage')}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
